import '../entrypoints/application.css'

import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { AppLayout } from '@/layouts/app-layout'

createInertiaApp({
  title: (title) => (title ? `${title} | Budget` : 'Budget'),
  resolve: async (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx')
    const page = await pages[`../pages/${name}.tsx`]()
    const component = page as { default: { layout?: (page: React.ReactNode) => React.ReactNode } }

    component.default.layout ??= (pageNode: React.ReactNode) => <AppLayout>{pageNode}</AppLayout>

    return component
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
  progress: {
    color: '#0f766e',
  },
})
